<template>
	<v-app>
		<div id="navigation" color="white" height="100" absolute app>
			<v-row v-if="experience.dataMap.showHeader" class="d-flex align-center" style="margin-left: 0; margin-right: 0">
				<v-col cols="4" class="pa-0">
					<img v-if="experience.logo" class="ml-4" height="50" contain :src="$root.asset(experience.logo)" @click="$store.commit('debug')" />
					<span v-else>{{ experience.name }}</span>
				</v-col>
				<v-col cols="4"  class="pa-0">
					<v-img v-if="experience.banner" class="ml-4 d-none d-sm-none d-md-flex" max-height="60" max-width="400" contain :src="$root.asset(experience.banner)"></v-img>
				</v-col>
				<v-col
                    cols="4"
                    class="d-flex justify-end pa-0"
                    v-if="!experience.dataMap.useMobileNavigation"
                >
					<v-app-bar-nav-icon class="hidden-sm-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>
					<v-list class="d-none d-sm-flex pa-0" two-line subheader>
						<v-list-item class="pa-0">
							<v-list-item-content class="text-right">
								<v-list-item-title>
									{{ $store.state.principal.firstName && $store.state.principal.firstName + " " + $store.state.principal.lastName }}
								</v-list-item-title>
								<v-list-item-subtitle>
									<a @click="cometLogout">Log out</a>
								</v-list-item-subtitle>
							</v-list-item-content>

							<v-menu rounded="xl">
								<template v-slot:activator="{ on, attrs }">
									<v-list-item-avatar size="40" v-bind="attrs" v-on="on" class="pr-2">
										<v-img v-if="$store.state.principal.image && !imgError" :src="baseLocation + '/asset/file/user/' + $store.state.principal.image" @error="imgError = !imgError"></v-img>
										<v-icon v-else size="40">mdi-account-circle</v-icon>
									</v-list-item-avatar>
								</template>

								<v-list v-if="$store.state.principal.role == 'Experience_User'" flat elevation="0">
									<v-subheader>Account</v-subheader>
									<v-list-item :to="'/' + tenantSlug + '/' + experienceSlug + '/profile'" link>
										<v-list-item-icon class="mr-4">
											<v-icon>mdi-face-profile</v-icon>
										</v-list-item-icon>

										<v-list-item-content>
											<v-list-item-title>Edit Profile</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item :to="'/' + tenantSlug + '/' + experienceSlug + '/changepassword'" link>
										<v-list-item-icon class="mr-4">
											<v-icon>mdi-lock-reset</v-icon>
										</v-list-item-icon>

										<v-list-item-content>
											<v-list-item-title>Change Password</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
			<v-row
                id="menu"
                class="d-none d-sm-flex justify-center"
                style="background-color: black; color: white; margin-left: 0; margin-right: 0"
                v-if="(experience.menuDataList && experience.menuDataList.length > 0)
                    && !experience.dataMap.useMobileNavigation"
            >
				<div v-for="(menu, idxMenu) in experience.menuDataList" :key="idxMenu">
					<v-menu v-if="menu.childList && menu.childList.length > 0" v-model="menu.state" right bottom offset-y rounded="0 b-lg" dark>
						<template v-slot:activator="{ on, attrs, value }">
							<v-btn text v-bind="attrs" v-on="on" dark tile>
								{{ menu.name }}
								<v-icon right dark>{{ value ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
							</v-btn>
						</template>

						<v-list color="black" dense>
							<div v-for="(subMenu, idxSubMenu) in menu.childList" :key="idxSubMenu">
								<v-menu v-if="subMenu.childList && subMenu.childList.length > 0" v-model="subMenu.state" offset-x rounded="l-0 r-lg" dark>
									<template v-slot:activator="{ on, attrs }">
										<v-list color="black" style="padding: 0 !important" dense>
											<v-hover v-slot:default="{ hover }">
												<v-list-item v-bind="attrs" v-on="on" dense>
													<v-list-item-icon>
														<v-img v-if="hover" contain aspect-ratio="1" :src="$root.asset(subMenu.iconHover)"></v-img>
														<v-img v-else contain aspect-ratio="1" :src="$root.asset(subMenu.icon)"></v-img>
													</v-list-item-icon>
													<v-list-item-content>
														<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ subMenu.name }}</v-list-item-title>
														<v-list-item-title v-else>{{ subMenu.name }}</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
											</v-hover>
										</v-list>
									</template>
									<v-list color="black" style="padding: 0 !important" dense>
										<v-list-item v-for="(item, idxItem) in subMenu.childList" :key="idxItem" @click="navigateTo(item), (menu.state = false)" link>
											<v-list-item-icon>
												<v-img contain aspect-ratio="1" :src="$root.asset(item.icon)"></v-img>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>{{ item.name }}</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>

								<v-hover v-else v-slot:default="{ hover }">
									<v-list-item @click="navigateTo(subMenu)" link>
										<v-list-item-icon>
											<v-img v-if="hover" contain aspect-ratio="1" :src="$root.asset(subMenu.iconHover)"></v-img>
											<v-img v-else contain aspect-ratio="1" :src="$root.asset(subMenu.icon)"></v-img>
										</v-list-item-icon>

										<v-list-item-content>
											<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ subMenu.name }}</v-list-item-title>
											<v-list-item-title v-else>{{ subMenu.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-hover>
							</div>
						</v-list>
					</v-menu>
					<v-btn v-else @click="navigateTo(menu)" class="hover-underline" tile text dark>{{ menu.name }}</v-btn>
				</div>
				<v-btn class="hover-underline" tile text dark @click="showListDocument" v-if="myDocument">My Documents</v-btn>
				<v-btn class="hover-underline" tile text dark @click="dialogLiveChat">Live Tech Support</v-btn>
				<v-switch v-if="$router.currentRoute.path.includes('/hall/')" class="white--text" v-model="$store.state.isFitToWidth" style="margin-top: 0px; align-items: center; text-transform: uppercase"  dense hide-details dark :label="'Fit to screen ' + ($store.state.isFitToWidth ? 'on' : 'off') " @change="setFitToScreen"></v-switch>
				<v-switch v-if="$router.currentRoute.path.includes('/hall/')" v-model="$store.state.showVideoTransition" style="margin-top: 0px; margin-left: 15px; align-items: center; text-transform: uppercase" dense hide-details dark :label="'Video Transition ' + ($store.state.showVideoTransition ? 'on' : 'off') " @change="setShowVideoTransition"></v-switch>
				<v-btn v-if="!experience.dataMap.showHeader" class="hover-underline" text dark @click="showEditProfile">{{ $store.state.principal.firstName && $store.state.principal.firstName + " " + $store.state.principal.lastName }}</v-btn>
				<v-btn v-if="!experience.dataMap.showHeader" class="hover-underline" tile text dark @click="cometLogout">Log out</v-btn>
			</v-row>
		</div>

		<!-- BURGER MENU  -->
        <!-- <div style="background-color: #fff !important; z-index: 6;">
            <v-tooltip v-if="experience.dataMap.useMobileNavigation" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="drawer = !drawer"
                        class="ma-5"
                        style="right: 0px;
                        z-index: 6;
						background-color: #757575;"
                        dark
                        right
                        icon
                        fixed
                        outlined
                        elevation="4"
                    >
						<v-icon dark large>
                            mdi-microsoft-xbox-controller-menu
                        </v-icon>
                    </v-btn>
                </template>
                <span>Menu</span>
            </v-tooltip>

            <v-tooltip v-if="!experience.dataMap.showHeader && !experience.dataMap.useMobileNavigation" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="drawer = !drawer"
                        class="ma-5 hidden-sm-and-up"
                        style="right: 0px;
                        z-index: 6;
						background-color: #757575;"
                        dark
                        right
                        icon
                        fixed
                        outlined
                        elevation="4"
                    >
						<v-icon dark large>
                            mdi-microsoft-xbox-controller-menu
                        </v-icon>
                    </v-btn>
                </template>
                <span>Menu</span>
            </v-tooltip>
        </div> -->

		<!-- MENU BUTTON  -->
        <div style="background-color: #fff !important; z-index: 6;">
            <v-tooltip v-if="experience.dataMap.useMobileNavigation" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="drawer = !drawer"
						class="ma-5 pa-1"
						style="right: 0;
						font-size: calc(10px + 0.2vw);
						min-width: 4.5em;
						height: 2.7em;
                        z-index: 6;
						background-color: #757575;"
                        dark
                        right
                        fixed
                        outlined
                        elevation="4"
                    >
						MENU
                    </v-btn>
                </template>
                <span>Menu</span>
            </v-tooltip>

            <v-tooltip v-if="!experience.dataMap.showHeader && !experience.dataMap.useMobileNavigation" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="drawer = !drawer"
                        class="ma-5 hidden-sm-and-up"
                        style="right: 0px;
                        z-index: 6;
						background-color: #757575;"
                        dark
                        right
                        fixed
                        outlined
                        elevation="4"
                    >
						MENU
                    </v-btn>
                </template>
                <span>Menu</span>
            </v-tooltip>
        </div>

		<v-navigation-drawer v-if="drawer" v-model="drawer" class="" hide-overlay absolute temporary right dark color="rgba(0, 0, 0, 0.8)">
			<v-list>
				<v-list-group color="white" no-action>
					<template v-slot:activator>
						<v-list-item-avatar>
							<v-img v-if="$store.state.principal.image" :src="baseLocation + '/asset/file/user/' + $store.state.principal.image"></v-img>
							<v-icon v-else size="60">mdi-account-circle</v-icon>
						</v-list-item-avatar>

						<v-list-item-content>
							<v-list-item-title>
								{{ $store.state.principal.firstName && $store.state.principal.firstName + " " + $store.state.principal.lastName }}
							</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item :to="'/' + tenantSlug + '/' + experienceSlug + '/profile'" link>
						<v-list-item-icon class="mr-4">
							<v-icon>mdi-face-profile</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>Edit Profile</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item :to="'/' + tenantSlug + '/' + experienceSlug + '/changepassword'" link>
						<v-list-item-icon class="mr-4">
							<v-icon>mdi-lock-reset</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>Change Password</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item @click="cometLogout()" link>
						<v-list-item-icon class="mr-4">
							<v-icon>mdi-logout-variant</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>Log out</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
			</v-list>

			<v-divider></v-divider>

			<v-list dense dark v-if="(experience.menuDataList && experience.menuDataList.length > 0) || myDocument">
				<div v-for="(menu, idxMenu) in experience.menuDataList" :key="idxMenu">
					<v-list-group v-if="menu.childList && menu.childList.length > 0" color="white">
						<template v-slot:activator>
							<v-list-item-content>
								<v-list-item-title>{{ menu.name }}</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-hover v-for="(subMenu, idxSubMenu) in menu.childList" :key="idxSubMenu" v-slot:default="{ hover }">
							<v-list-group v-if="subMenu.childList && subMenu.childList.length > 0" class="pl-0" sub-group color="white">
								<template v-slot:activator>
									<v-list-item-content>
										<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ subMenu.name }}</v-list-item-title>
										<v-list-item-title v-else>{{ subMenu.name }}</v-list-item-title>
									</v-list-item-content>
								</template>
								<v-hover v-for="(item, idxItem) in subMenu.childList" :key="idxItem" v-slot:default="{ hover }">
									<v-list-item @click="navigateTo(item)" link>
										<v-list-item-icon class="mr-2">
											<v-img v-if="hover" contain aspect-ratio="1" :src="$root.asset(item.iconHover)"></v-img>
											<v-img v-else contain aspect-ratio="1" :src="$root.asset(item.icon)"></v-img>
										</v-list-item-icon>

										<v-list-item-content>
											<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ item.name }}</v-list-item-title>
											<v-list-item-title v-else>{{ item.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-hover>
							</v-list-group>
							<v-list-item v-else @click="navigateTo(subMenu)" link>
								<v-list-item-icon class="mr-2">
									<v-img v-if="hover" contain aspect-ratio="1" :src="$root.asset(subMenu.iconHover)"></v-img>
									<v-img v-else contain aspect-ratio="1" :src="$root.asset(subMenu.icon)"></v-img>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-title v-if="hover" style="color: #eb6e1f">{{ subMenu.name }}</v-list-item-title>
									<v-list-item-title v-else>{{ subMenu.name }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-hover>
					</v-list-group>
					<v-list-item v-else @click="navigateTo(menu)" link>
						<v-list-item-icon v-if="menu.icon">
							<v-icon>{{ menu.icon }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{ menu.name }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</div>
				<v-list-item @click="showListDocument" v-if="myDocument">
					<v-list-item-icon v-if="false"></v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>My Documents</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item @click="dialogLiveChat">
					<v-list-item-icon v-if="false"></v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Live Tech Support</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item v-if="$router.currentRoute.path.includes('/hall/')">
					<v-list-item-title>
						Fit to screen
					</v-list-item-title>
					<v-switch v-model="$store.state.isFitToWidth" style="margin-top: 0px; align-items: center; color: white;" color="#eb6e1f" dense hide-details dark @change="setFitToScreen"></v-switch>
				</v-list-item>
				<v-list-item v-if="$router.currentRoute.path.includes('/hall/')">
					<v-list-item-title>
						Video Transition
					</v-list-item-title>
					<v-switch v-model="$store.state.showVideoTransition" style="margin-top: 0px; align-items: center; color: white;" color="#eb6e1f" dense hide-details dark  @change="setShowVideoTransition"></v-switch>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<router-view :vchat="vchat"></router-view>
		<v-dialog v-model="showDialogHelp" content-class="col-sm-6 col-12 hide-box-shadow">
			<v-card rounded="xl" dark color="#363636">
				<v-card-title>
					<span style="font-size: 14px" class="d-flex justify-center">
						<v-icon medium>mdi-help-circle-outline</v-icon>
						<span class="ml-2">Help</span>
					</span>
					<v-spacer></v-spacer>
					<v-icon @click="showDialogHelp = false">mdi-close-circle-outline</v-icon>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text v-if="!isSendMessage" style="margin-top: 20px">
					<form @submit.prevent="sendMessage">
						<v-textarea label="Message" v-model="message" :rules="[(v) => !!v || 'Messge is required']" required></v-textarea>
						<div class="d-flex justify-end">
							<v-btn type="submit">SEND</v-btn>
						</div>
					</form>
				</v-card-text>
				<v-card-text v-else style="margin-top: 20px">
					<h3>Thank you for contacting our V-Unite support team! One of our team members will be in touch as soon as possible to address this issue.</h3>
					<br />
					<h3>The V-Unite Team</h3>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showMyDocuments" content-class="col-sm-8 col-12 hide-box-shadow">
			<v-card rounded="xl" dark color="#363636">
				<v-card-title>
					<span style="font-size: 14px" class="d-flex justify-center">
						<v-icon small>mdi-file-document</v-icon>
						<span class="ml-2">Saved Documents</span>
					</span>
					<v-spacer></v-spacer>
					<v-icon @click="showMyDocuments = false">mdi-close-circle-outline</v-icon>
				</v-card-title>
				<v-card class="d-flex justify-center align-center mb-6" color="black" dark height="40px" tile>
					<v-text-field v-model="searchParam" @input="searchDocument" placeholder="Search Documents" prepend-inner-icon="mdi-magnify" hide-details dark dense rounded style="margin-top: 0"></v-text-field>
					<v-btn color="white" style="text-transform: none; margin-right: 15px" rounded width="160" class="black--text" @click="downloadSelectedDocument">Download Selected</v-btn>
				</v-card>
				<v-card-text>
					<ul style="padding-left: 0" v-for="(doc, idxDoc) in userDocumentFiltered" :key="idxDoc">
						<li>
							<v-row>
								<v-col cols="6" sm="10">
									<div style="margin-top: 20px; display: flex; flex-direction: row; justify-content: flex-start">
										<v-checkbox v-model="emailSelected" color="orange" :value="doc.id"></v-checkbox>
										<span style="margin-top: 20px; width: 100%">
											<v-icon>mdi-file-pdf</v-icon>
											{{ doc.title }}
										</span>
									</div>
								</v-col>
								<v-col cols="6" sm="2">
									<div style="display: flex; flex-direction: row; justify-content: flex-end; margin-top: 35px">
										<v-btn class="ml-2" rounded small @click="removeDocument(doc)" style="text-transform: none">Remove</v-btn>
										<v-btn v-if="doc.dataMap.openLinkOption && doc.dataMap.openLinkOption == '1'" color="#5F949C" rounded small class="ml-2">
											<a target="_blank" style="background-color: transparent; text-transform: none; text-decoration: none; color: white" :href="$root.asset(doc.value)">View</a>
										</v-btn>
										<v-btn v-else class="ml-2" rounded small @click="openDocument(doc)" style="text-transform: none" color="#5F949C">View</v-btn>
									</div>
								</v-col>
							</v-row>
						</li>
						<hr class="horizontal-line my-4" />
					</ul>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showDocument" content-class="col-md-8 col-12 hide-box-shadow" persistent>
			<v-card v-if="selectedDocument != null">
				<v-card-title>
					<span class="headline">{{ selectedDocument.title }}</span>
					<v-spacer></v-spacer>
					<v-icon @click="showDocument = false">mdi-close</v-icon>
				</v-card-title>
				<div v-if="selectedDocument.type == 'Business_Card'">
					<v-row class="pa-2"  v-for="(item, index) in selectedDocument.value" :key="index" justify="center">
						<v-img  :src="baseLocation + '/asset/file/businesscard/' + item" max-width="420px" max-height="240" contain></v-img>
					</v-row>
				</div>
				<iframe v-else id="vd-vault-1" frameborder="0" allow="autoplay; encrypted-media" scrolling="0" width="100%" height="450" :src="$root.asset(selectedDocument.value)" allowfullscreen></iframe>
			</v-card>
		</v-dialog>


		<!-- Networking Lounge -->
		<v-dialog v-model="networkingLounge.showDialog" fullscreen persistent no-click-animation>
			<template>
			<matchAndFind :extData="networkingLounge" :tenantSlug="tenantSlug" :experienceSlug="experienceSlug" :networkingLounge="networkingLounge" ref="matchAndFind"/>
			</template>
		</v-dialog>

		<v-dialog v-model="$store.state.notification.show" width="500" v-if="$store.state.notification.title != 'Unknown error'">
			<v-card style="padding: 20px">
				<!-- <div style="display: flex; justify-content: space-between">
					<h2 v-if="$store.state.notification.withoutTitle == null || $store.state.notification.withoutTitle == false" style="margin-bottom: 10px">Whoops! ({{ $store.state.notification.title }})</h2>
					<h2 v-else style="margin-bottom: 10px"></h2>
					<v-btn icon color="secondary" @click="closeNotification()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div> -->
				
				<div class="text-center mb-5">
					<h2 v-if="$store.state.notification.withoutTitle == null || $store.state.notification.withoutTitle == false"
					style="margin-bottom: 10px; font-size: larger;"
					>Something Went Wrong</h2>
					<h2 v-else style="margin-bottom: 10px"></h2>
				</div>

				<template v-if="$store.state.notification.content && $store.state.notification.content.type == 'NOTIFICATION'">
					<div class="text-center" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content.fieldErrorList" v-html="item"></div>
					<div class="text-center" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content.errorList" v-html="item"></div>
					<div class="text-center" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content.noticeList" v-html="item"></div>
				</template>
				<template v-else>
					<div class="text-center">{{ $store.state.notification.content }}</div>
				</template>

				<div class="text-center mt-5 mr-10 ml-10">
					<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
					style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
				</div>
				<div style="text-align: center; margin-top: 20px">
					<v-btn color="#009ec1" @click="closeNotification">Close</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-overlay style="z-index: 999" :value="$root.loader.value" opacity="0">
			<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
		</v-overlay>
		<v-snackbar v-model="snackbar">
			{{ snackbarContent }}
			<template v-slot:action="{ attrs }">
				<v-btn color="red" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
			</template>
		</v-snackbar>
		<!-- NOTIFICATION -->
		<div style="position: fixed; bottom: 16px; left: 16px; z-index: 999; max-height: 100vh; overflow-y: auto; overflow-x: hidden;">
			<template v-for="(item, index) in notificationList">
				<v-alert :key="index" v-if="!item.ticketTypeList || $store.state.principal.ticketList.find((obj) => item.ticketTypeList.includes(obj.name))" v-model="item.show" color="primary" colored-border elevation="2" border="left" max-width="300" icon="mdi-information" dismissible transition="slide-x-reverse-transition">
					{{ item.message }}
				</v-alert>
			</template>
		</div>
		<div v-append="beacon"></div>
	</v-app>
</template>

<style scoped>
/* Animation hover underline */
.link-hover {
	color: rgba(255, 255, 255, 0.5);
	text-decoration: none;
	background: linear-gradient(#eb6e1f, #eb6e1f) bottom / 0 0.2em no-repeat;
	transition: 0.5s background-size;
}

.link-hover:hover {
	background-size: calc(100%) 0.2em;
}
</style>

<style>
.hide-box-shadow {
	box-shadow: none !important;
}
.white--text > div > div > label{
    color: white !important;
}
</style>
<script>
/* eslint-disable */
import axios from "axios";
import configuration from "../../configuration";
import { CometChat } from "@cometchat-pro/chat";
import matchAndFind from "./matchAndFind.vue";

export default {
	props: ["tenantSlug", "experienceSlug", "vchat"],
	components: {
		"matchAndFind": matchAndFind
	},
	data() {
		return {
			drawer: false,
			mini: false,
			menuRoot: false,
			experience: {
                dataMap:{
                    showHeader: false,
                    useMobileNavigation: false,
                }
            },
			structureList: [],
			showMyDocuments: false,
			userDocumentFiltered: [],
			userDocumentList: [],
			showDocument: false,
			selectedDocument: {},
			searchParam: "",
			baseLocation: axios.defaults.baseURL,
			emailSelected: [],
			snackbar: false,
			snackbarContent: null,
			networking: false,
			myDocument: false,
			networkingLounge : {
				showDialog: false,
				isFristLoad: true
			},
			imgError: false,
			showDialogHelp: false,
			message: "",
			isSendMessage: false,
			beacon: this.$root.initLiveSupport(),
			isMobile: false,
			btnCloseLiveTechSupportSyle: {
				bottom: "678px",
				right: "40px"
			},
			notificationList: []
		};
	},
	mounted() {
		this.getExperience();
		if(!this.$store.state.principal.chatUserToken) {
			this.notificationlistener();
		}
		if (this.$store.state.showNetworkingLounge) {
			this.networkingLounge.showDialog = true;
			if (!this.networkingLounge.isFristLoad) {
				this.$refs.matchAndFind.findThemeColor();
				this.$refs.matchAndFind.listMyInterest();
				this.$refs.matchAndFind.listInterest();
				this.$refs.matchAndFind.listAttendee();
				this.$refs.matchAndFind.listExhibitor();
				this.$refs.matchAndFind.getExperience();
			}
		}
	},
	methods: {
		downloadSelectedDocument() {
			this.snackbar = true;
			this.snackbarContent = "Please wait..";
			axios
				.post("/system/document/briefcase/downloadSelected", {
					experienceUserId: this.$store.state.principal.id,
					documentList: this.emailSelected
				})
				.then((response) => {
					this.download(response.data);
				});
		},
		download(url) {
			window.open(this.baseLocation + "/asset/file/" + url, "_blanks");
		},
		getExperience() {
			axios
				.get("/system/experience/find")
				.then((response) => {
					this.experience = response.data;
					if (this.experience.dataMap.showHeader == null) {
						this.experience.dataMap.showHeader = true;
					}

                    if (
                        this.experience.dataMap.useMobileNavigation == 'undefined'
                        || this.experience.dataMap.useMobileNavigation == null
                    ) {
						this.experience.dataMap.useMobileNavigation = false;
					}

					this.getTotalDocument();
				})
				.catch(() => {});
		},
		getTotalDocument() {
			axios
				.get("/system/experience/count/document")
				.then((response) => {
					let totalDocument = response.data;
					if (totalDocument > 0) {
						this.myDocument = true;
					}
				})
				.catch(() => {});
		},
		async cometLogout() {
			try {
				if(!this.$store.state.principal.chatUserToken) {
					let user = await CometChat.getLoggedinUser();
					if (user) {
						user.role = "default";
						await CometChat.updateUser(user, configuration.apiKeyCometChat);

						let busId = this.$store.state.principal.experienceId + "-bus";
						await CometChat.sendMessage(new CometChat.TextMessage(busId, JSON.stringify({ type: "Logout" }), CometChat.RECEIVER_TYPE.GROUP));

						await CometChat.logout();
					}
				}
			} finally {
				this.logout();
			}
		},
		logout() {
			let activityLog = { type: "Logout_from_the_event" };
			this.$root.saveActivityLog(activityLog);
			this.$store.dispatch("logout").then(() => {
				this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug);
				Beacon("destroy");
			});
		},
		showListDocument() {
			axios.get("/system/document/briefcase/list?experienceUserId=" + this.$store.state.principal.id).then((response) => {
				this.userDocumentFiltered = response.data;
				this.userDocumentList = this.userDocumentFiltered;
				this.showMyDocuments = true;
			});
		},
		openDocument(doc) {
			this.selectedDocument = null;
			axios.get("/system/booth/document?id=" + doc.id).then((response) => {
				this.selectedDocument = response.data;
				if(this.selectedDocument.type == 'Business_Card'){
					this.selectedDocument.value = JSON.parse(this.selectedDocument.value);
				}
				this.showDocument = true;
			});
		},
		removeDocument(doc) {
			axios
				.post("/system/document/briefcase/remove", {
					experienceUserId: this.$store.state.principal.id,
					documentId: doc.id
				})
				.then(() => {
					let activityLog = {
						dataMap: {
							boothId: doc.boothId,
							presentationId: doc.presentationId,
							documentId: doc.id
						},
						type: "Remove_from_my_documents"
					};
					this.$root.saveActivityLog(activityLog);
					this.showListDocument();
				});
		},
		searchDocument() {
			if (this.searchParam == "") {
				this.userDocumentFiltered = this.userDocumentList;
			} else {
				this.userDocumentFiltered = this.userDocumentList.filter((r) => this.searchArray(this.searchParam, false, r.title));
			}
		},
		searchArray(searchTerm, caseSensitive, ...values) {
			if (!searchTerm) {
				return true;
			}

			let filter = searchTerm.trim();
			let data = values.join();

			if (!caseSensitive) {
				filter = filter.toLowerCase();
				data = data.toLowerCase();
			}

			return data.indexOf(filter) != -1;
		},
		navigateTo(menu) {
			if (menu.linkTo && menu.linkType === "URL") {
				let activityLog = {
					type: "Navigation_url",
					dataMap: { value: menu.linkTo }
				};
				this.$root.saveActivityLog(activityLog);

				window.open(menu.linkTo, "_blank");
			} else if (menu.linkTo && menu.linkType === "Room") {
				const path = "/" + this.tenantSlug + "/" + this.experienceSlug + "/hall/" + menu.linkTo;

				if (this.$route.path !== path) {
					this.$router.push(path);
				}
			} else if (menu.linkType === "Leaderboard") {
				const path = "/" + this.tenantSlug + "/" + this.experienceSlug + "/leaderboard";

				if (this.$route.path !== path) {
					this.$router.push(path);
				}
			} else if (menu.linkType === "Networking Lounge") {
				this.networkingLounge.showDialog = true;
				if (!this.networkingLounge.isFristLoad) {
					this.$refs.matchAndFind.findThemeColor();
					this.$refs.matchAndFind.listMyInterest();
					this.$refs.matchAndFind.listInterest();
					this.$refs.matchAndFind.listAttendee();
					this.$refs.matchAndFind.listExhibitor();
					this.$refs.matchAndFind.getExperience();
				}
				this.$store.commit("setShowNetworkingLounge", true);
			}
		},
		closeNotification() {
			if (this.$store.state.notification.title === "Unauthorized") {
				this.$store.commit("hideNotification");
				this.$store.commit("logout");
				this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug);
			} else if (this.$store.state.notification.title === "Forbidden") {
				this.$store.commit("hideNotification");
				this.$router.go(-1);
			} else if (this.$store.state.notification.title === "CometChat error") {
				if (this.$store.state.notification.content.errorList[0] == 'There is already a call in progress') {
					location.reload();
				}
				this.$store.commit("hideNotification");
			} else {
				this.$store.commit("hideNotification");
			}
		},
		sendMessage() {
			axios
				.post("/system/experience/help/sendEmail", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					message: this.message
				})
				.then((response) => {
					if (response.data) {
						this.message = "";
						this.isSendMessage = true;
					}
				});
		},
		dialogHelp() {
			this.showDialogHelp = true;
			this.isSendMessage = false;
		},
		dialogLiveChat() {
			this.$root.dialogLiveSupport(this.experience.dataMap.tenantName, this.experience.name);
		},
		async notificationlistener() {
			CometChat.addMessageListener(
				"messageListener-" + this.$store.state.principal.experienceId + "-bus",
				new CometChat.MessageListener({
					onTextMessageReceived: (textMessage) => {
						if (textMessage.receiverId == this.$store.state.principal.experienceId + "-bus") {
							let data = JSON.parse(textMessage.data.text);
							for (let i = 0; i < data.length; i++) {
								if (data[i].type == "Notification") {
									this.notificationList = this.notificationList.concat(data.filter((item) => !this.notificationList.some(obj => item.date === obj.date && item.message === obj.message)));
								}
							}
						}
					}
				})
			);
		},
		setShowVideoTransition() {
			this.$store.commit('setShowVideoTransition', this.$store.state.showVideoTransition);
		},
		setFitToScreen() {
			this.$store.commit('setFitToWidth', this.$store.state.isFitToWidth);
		},
		showEditProfile() {
			window.location.href = '/#/' + this.tenantSlug + '/' + this.experienceSlug + '/profile';
		}
	}
};
</script>